<template>
  <div class="qualificationApplication">
    <div v-if="isShow" class="quaul">
      <personalHead
        title="实名认证"
        :hide="true"
        :back="disabled"
        @goBack="goBack"
      />
      <div class="form">
        <el-form
          :model="ruleForm"
          status-icon
          :rules="rules"
          ref="ruleForm"
          label-width="200px"
          class="demo-ruleForm"
        >
          <el-row :gutter="20">
            <!--企业信息-->
            <el-col :xs="24" :sm="24" :md="24">
              <el-form-item label="机构名称" required>
                <el-form-item label prop="company_name">
                  <el-input
                    v-model="ruleForm.company_name"
                    placeholder="请输入机构名称"
                  ></el-input>
                </el-form-item>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24">
              <el-form-item label="机构统一社会代码" required>
                <el-form-item label prop="credit_no">
                  <el-input
                    v-model="ruleForm.credit_no"
                    placeholder="请输入机构统一社会代码"
                  ></el-input>
                </el-form-item>
              </el-form-item>
            </el-col>
            <!-- 法人身份证照 -->

            <el-col :xs="24" :sm="24" :md="24">
              <el-form-item
                label="机构营业执照"
                :error="error"
                :required="true"
              >
                <el-upload
                  class="avatar-uploader center"
                  action="#"
                  accept=".png, .jpeg, .jpg"
                  :auto-upload="false"
                  :multiple="false"
                  :show-file-list="false"
                  :on-change="loadJsonFromFile"
                  :disabled="disabled"
                >
                  <img
                    v-if="imageUrl"
                    :src="imageUrl"
                    class="avatar"
                    @mouseover="imgMouseover"
                  />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  <div
                    class="el-upload-show"
                    :style="active"
                    @mouseleave="imgMouseleave"
                  >
                    <span class="el-upload-span1">
                      <span
                        class="el-upload-list__item-preview"
                        @click.stop="handlePictureCardPreview()"
                      >
                        <i class="el-icon-zoom-in"></i>
                      </span>
                      <span
                        @click.stop="handleRemove()"
                        v-if="!formInfo.credit_image_path"
                      >
                        <i class="el-icon-delete"></i>
                      </span>
                    </span>
                  </div>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="dialogImageUrl" alt />
                </el-dialog>
              </el-form-item>
            </el-col>

            <!--法人信息-->
            <el-col :xs="24" :sm="24" :md="24">
              <el-form-item label="法人/授权代表姓名" required>
                <el-form-item label prop="legal_name">
                  <el-input
                    v-model="ruleForm.legal_name"
                    placeholder="请输入法人/授权代表姓名"
                  ></el-input>
                </el-form-item>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24">
              <el-form-item label="法人/授权代表证件号" required>
                <el-form-item label prop="legal_id">
                  <el-input
                    v-model="ruleForm.legal_id"
                    placeholder="请输入法人/授权代表证件号"
                  ></el-input>
                </el-form-item>
              </el-form-item>
            </el-col>
            <!-- 法人身份证照 -->

            <el-col :xs="24" :sm="24" :md="24">
              <el-form-item
                label="法人/授权代表身份证照"
                :error="errorCardNum"
                :required="true"
              >
                <el-upload
                  class="avatar-uploader center"
                  action="#"
                  accept=".png, .jpeg, .jpg"
                  :auto-upload="false"
                  :multiple="false"
                  :show-file-list="false"
                  :on-change="loadJsonFromFileAbc"
                  :disabled="disabled"
                >
                  <img
                    v-if="legal_id_front_path"
                    :src="legal_id_front_path"
                    class="avatar"
                    @mouseover="imgMouseoverAbc"
                  />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  <div
                    class="el-upload-show"
                    :style="activeAbc"
                    @mouseleave="imgMouseleaveAbc"
                  >
                    <span class="el-upload-span1">
                      <span
                        class="el-upload-list__item-preview"
                        @click.stop="handlePictureCardPreviewAbc()"
                      >
                        <i class="el-icon-zoom-in"></i>
                      </span>
                      <span
                        @click.stop="handleRemoveAbc()"
                        v-if="!formInfo.legal_id_front_path"
                      >
                        <i class="el-icon-delete"></i>
                      </span>
                    </span>
                  </div>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="dialogImageUrl" alt />
                </el-dialog>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24">
              <el-form-item label="法人/授权代表手机号" required>
                <el-form-item label prop="legal_mobile">
                  <el-input
                    v-model="ruleForm.legal_mobile"
                    placeholder="请输入法人/授权代表手机号"
                  ></el-input>
                </el-form-item>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24">
              <el-form-item label="法人/授权代表银行卡号" required>
                <el-form-item label prop="bank_card_no">
                  <el-input
                    v-model="ruleForm.bank_card_no"
                    placeholder="请输入法人/授权代表银行卡号"
                  ></el-input>
                </el-form-item>
              </el-form-item>
            </el-col>
            <!--企业信息-->
            <el-col :xs="24" :sm="24" :md="24">
              <el-form-item label="机构银行账号" required>
                <el-form-item label prop="bank_id">
                  <el-input
                    v-model="ruleForm.bank_id"
                    placeholder="请输入机构银行账号"
                  ></el-input>
                </el-form-item>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24">
              <el-form-item label="机构银行名称" required>
                <el-form-item label prop="bank_name">
                  <el-input
                    v-model="ruleForm.bank_name"
                    placeholder="请输入机构银行名称"
                  ></el-input>
                </el-form-item>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24">
              <el-form-item label="机构开户行名称" required>
                <el-form-item label prop="subbranch_name">
                  <el-input
                    v-model="ruleForm.subbranch_name"
                    placeholder="请输入机构开户行名称"
                  ></el-input>
                </el-form-item>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24">
              <el-form-item class="submit">
                <!-- 审批未通过 -->
                <el-button
                  type="danger"
                  @click="save('ruleForm')"
                  v-if="!disabled"
                  >提 交</el-button
                >
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <div v-else>
      <personalHeadSeal
        title="法大大"
        :hide="true"
        :back="disabled"
        @goBack="goBack"
      />
      <div class="add">
        <el-button
          type="primary"
          size="medium"
          @click="realNameAuthen"
          :disabled="false"
          >重新实名认证</el-button
        >
      </div>
      <iframe
        name="iframeMap"
        id="iframeMapViewComponent"
        v-bind:src="getPageUrl"
        width="100%"
        height="770px"
        frameborder="0"
        scrolling="yes"
        ref="iframeDom"
      ></iframe>
    </div>
  </div>
</template>

<script>
import personalHeadSeal from "@/views/admin/components/personalHeadSeal.vue";
import personalHead from "@/views/admin/components/personalHead.vue";
import {
  CreateQualifications,
  GetTestQualificationsDetails,
  GetCompanyVerifyUrl,
  GetUserTestMechanismDetail,
} from "@/api/admin/test.js";
//api/services/app/Contract/Applycert
import { GetDicData, GetDistrictList } from "@/api/admin/common.js";
import { mapGetters } from "vuex";
let that;
export default {
  components: {
    personalHead,
    personalHeadSeal,
  },
  computed: {
    ...mapGetters(["personalInfo"]),
  },
  data() {
    return {
      ruleForm: {},
      formInfo: {},
      form: {},
      formList: [],
      isShow: true,
      getPageUrl: "",
      rules: {
        credit_image_path: [
          { required: true, message: "请上传机构营业执照", trigger: "blur" },
        ],
        legal_id_front_path: [
          {
            required: true,
            message: "请上传法人/授权代表身份证照",
            trigger: "blur",
          },
        ],
        bank_id: [
          {
            required: true,
            message: "请填写机构银行账号",
            trigger: "blur",
          },
        ],
        bank_name: [
          {
            required: true,
            message: "请填写机构银行名称",
            trigger: "blur",
          },
        ],
        subbranch_name: [
          {
            required: true,
            message: "请填写机构开户行名称",
            trigger: "blur",
          },
        ],
        company_name: [
          {
            required: true,
            message: "请填写机构名称",
            trigger: "blur",
          },
        ],
        credit_no: [
          {
            required: true,
            message: "请填写机构统一社会信用代码",
            trigger: "blur",
          },
        ],

        legal_id: [
          {
            required: true,
            message: "请填写法人/授权代表证件号",
            trigger: "blur",
          },
        ],
        legal_name: [
          {
            required: true,
            message: "请填写法人/授权代表姓名",
            trigger: "blur",
          },
        ],
        legal_mobile: [
          {
            required: true,
            message: "请填写法人/授权代表手机号",
            trigger: "blur",
          },
        ],
        bank_card_no: [
          {
            required: true,
            message: "请填写法人/授权代表银行卡号",
            trigger: "blur",
          },
        ],
      },
      isdisabled: false,
      disabled: false,
      loading: false,
      uploadFiles: [],
      localFile: {},
      localFileAbc: {},
      error: "",
      errorCardNum: "",
      error1: "",
      dialogVisible: false,
      dialogImageUrl: "",
      active: "",
      activeAbc: "",
      imageUrl: "",
      legal_id_front_path: "",
      dicData: {
        test_class_can_apply_for_grade: "test_class_can_apply_for_grade",
        event_apply_status: "event_apply_status",
      },
      event_apply_status: [],
      imgPath: window.apiObj.apiUrl,
    };
  },
  created() {
    //this.imageUrl = this.personalInfo.credit_image_path;
    this.imageCreUrl = this.personalInfo.credit_image_path;
    this.imageUrl = this.personalInfo.legal_id_front_path;
    this.getVal();
  },
  watch: {},
  methods: {
    //实名认证   realNameAuthen   applicationCer
    realNameAuthen() {
      this.isShow = true;
      this.getPageUrl = "";
    },
    //查询内容  XXL   2020年11月13日 10:25:04
    getVal() {
      this.loading = true;
      //2020年11月9日 11:35:07     XXL
      var dataVal = {}; //{ classCode: "certificate_grade" };
      GetUserTestMechanismDetail(dataVal).then((data) => {
        var dataResult = data.data.result;

        if (dataResult.isSuccess == true) {
          var __verifyUrl = dataResult.testMechanismResult.verifyUrl;
          if (__verifyUrl != null && __verifyUrl != "") {
            this.isShow = false;
            this.getPageUrl = __verifyUrl;
          }
        }
      });
    },
    apply() {
      this.isShow = true;
    },
    goBack() {
      this.isShow = false;
    },
    save(ruleForm) {
      this.form.isFormSubmit = true;
      this.form.credit_image_path = this.localFile;
      this.form.legal_id_front_path = this.localFileAbc;

      this.form.bank_card_no = this.ruleForm.bank_card_no;
      this.form.bank_id = this.ruleForm.bank_id;
      this.form.bank_name = this.ruleForm.bank_name;
      this.form.company_name = this.ruleForm.company_name;
      this.form.credit_no = this.ruleForm.credit_no;
      this.form.legal_id = this.ruleForm.legal_id;
      this.form.legal_mobile = this.ruleForm.legal_mobile;
      this.form.legal_name = this.ruleForm.legal_name;
      this.form.subbranch_name = this.ruleForm.subbranch_name;

      if (!this.imageUrl) {
        this.error = "请上传机构营业执照";
        return false;
      } else {
        this.error = "";
      }
      if (!this.legal_id_front_path) {
        this.errorCardNum = "请上传法人/授权代表身份证 ";
        return false;
      } else {
        this.errorCardNum = "";
      }

      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          this.loading = true;
          //2020年11月9日 11:35:07     XXL
          GetCompanyVerifyUrl(this.form)
            .then((data) => {
              this.loading = false;
              if (data.data.result.code == 1 || data.data.result.code == "1") {
                this.isShow = false;
                this.getPageUrl = data.data.result.data.url; //data.data.result.data.transactionNo;
              } else {
                this.$message({
                  message: data.data.result.msg,
                  type: "success",
                });
              }
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    },

    handlePictureCardPreview() {
      this.dialogVisible = true;
      this.dialogImageUrl = this.imageUrl;
    },
    handleRemove() {
      this.imageUrl = "";
      this.localFile = {};
      this.active = "display:none;opacity: 0;";
    },
    loadJsonFromFile(file) {
      this.localFile = file.raw;
      let reader = new FileReader();
      reader.readAsDataURL(this.localFile);
      reader.onload = () => {
        const isJPG =
          this.localFile.type === "image/jpeg" ||
          this.localFile.type === "image/png";
        const isLt4M = this.localFile.size / 1024 / 1024 < 4;
        if (!isJPG) {
          this.localFile = {};
          this.$message.error("上传营业执照只能是 JPG/PNG 格式!");
        } else {
          this.imageUrl = reader.result;
        }
        if (!isLt4M) {
          this.$message.error("上传机构营业执照大小不能超过 4MB!");
        }
        return isJPG && isLt4M;
      };
    },
    handlePictureCardPreviewAbc() {
      this.dialogVisible = true;
      this.dialogImageUrl = this.imageUrl;
    },
    handleRemoveAbc() {
      this.legal_id_front_path = "";
      this.localFileAbc = {};
      this.activeAbc = "display:none;opacity: 0;";
    },
    loadJsonFromFileAbc(file) {
      this.localFileAbc = file.raw;
      let reader = new FileReader();
      reader.readAsDataURL(this.localFileAbc);
      reader.onload = () => {
        const isJPG =
          this.localFileAbc.type === "image/jpeg" ||
          this.localFileAbc.type === "image/png";
        const isLt4M = this.localFileAbc.size / 1024 / 1024 < 4;
        if (!isJPG) {
          this.localFileAbc = {};
          this.$message.error("身份证照只能是 JPG/PNG 格式!");
        } else {
          this.legal_id_front_path = reader.result;
        }
        if (!isLt4M) {
          this.$message.error("身份证照大小不能超过 4MB!");
        }
        return isJPG && isLt4M;
      };
    },
    imgMouseover() {
      this.active = "display:block;opacity: 1;";
    },
    imgMouseleave() {
      this.active = "display:none;opacity: 0;";
    },
    imgMouseoverAbc() {
      this.activeAbc = "display:block;opacity: 1;";
    },
    imgMouseleaveAbc() {
      this.activeAbc = "display:none;opacity: 0;";
    },
  },
  beforeCreate: function () {
    that = this;
  },
  filters: {},
};
</script>
<style lang="less">
.qualificationApplication {
  .form {
    width: 90%;
    .el-form-item__label {
      padding-right: 42px;
      font-size: 14px;
      font-weight: 400;
    }
    .el-textarea__inner {
      min-height: 150px !important;
      font-family: "微软雅黑";
    }
    .agree .el-checkbox__input {
      position: relative;
      top: -20px;
    }
    .border {
      .el-input__inner {
        border-width: 0px !important;
      }
    }
    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }
    .avatar {
      width: 178px;
      height: 178px;
      display: block;
    }
    .el-upload-show {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      text-align: center;
      color: #fff;
      opacity: 0;
      display: none;
      font-size: 20px;
      background-color: rgba(0, 0, 0, 0.5);
      transition: opacity 0.3s;
      line-height: 9;
      .el-upload-span1 {
        span {
          padding: 0px 20px;
        }
      }
    }
  }
  .quaul {
    width: 65%;
    padding: 5% 10px 10% 10px;
    .apply {
      padding: 10px 30px 10px 0px;
      text-align: right;
    }
    ul {
      li {
        height: 40px;
        line-height: 40px;
        .qast-sp1 {
          display: inline-block;
          width: 40%;
          text-align: right;
          color: #888;
        }
        @media screen and (max-width: 500px) {
          .qast-sp1 {
            width: 30% !important;
          }
        }
        .qast-sp2 {
          margin-left: 50px;
          color: #444;
        }
      }
    }
    .table {
      width: 100%;
      margin: 0 auto;
      margin-top: 50px;
      font-size: 0.9rem;
      .dot {
        width: 5px;
        height: 5px;
        display: inline-block;
        border-radius: 50%;
        position: relative;
        top: -3px;
        background-color: #f15660;
        margin-right: 5px;
      }
      .thead_title {
        display: inline-block;
        padding-left: 22px;
        margin-bottom: 10px;
      }
      ::-webkit-scrollbar {
        width: 7px;
      }

      /*外层轨道。可以用display:none让其不显示，也可以添加背景图片，颜色改变显示效果*/

      ::-webkit-scrollbar-track {
        width: 6px;
        background-color: #c0c4cc;
        -webkit-border-radius: 2em;
        -moz-border-radius: 2em;
        border-radius: 2em;
      }

      /*滚动条的设置*/

      ::-webkit-scrollbar-thumb {
        background-color: #8dc3ff;
        background-clip: padding-box;
        min-height: 28px;
        -webkit-border-radius: 2em;
        -moz-border-radius: 2em;
        border-radius: 2em;
      }
      tbody {
        text-align: center;
        display: block;
        overflow-x: hidden;
        tr {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 10px;
        }
      }
    }
    @media screen and (max-width: 768px) {
      .table {
        width: 100% !important;
      }
    }
  }
  .el-page-header {
    padding: 5px 20px;
  }
  @media screen and (max-width: 1024px) {
    .quaul {
      width: 100% !important;
    }
  }
  @media screen and (max-width: 500px) {
    .form {
      width: 100% !important;
      .el-form-item__label {
        width: 110px !important;
        float: none;
      }
      .el-form-item__content {
        margin-left: 0px !important;
        float: none;
      }
      .center {
        text-align: center;
      }
      .content {
        .el-form-item__content {
          margin-left: 0px !important;
        }
      }
    }
  }
}
</style>
